import { render, staticRenderFns } from "./product_avatars.vue?vue&type=template&id=ef5f2efa"
import script from "./product_avatars.vue?vue&type=script&lang=js"
export * from "./product_avatars.vue?vue&type=script&lang=js"
import style0 from "./product_avatars.vue?vue&type=style&index=0&id=ef5f2efa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports